/** "Raise Xero invoice" for a training booking + status pill once raised (auto-clears when Xero shows it paid). */
import React, { useState } from 'react';
import { ExternalLink, FileText, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import API_URL from '@/config/api';

export function TrainingXeroInvoice({ reg, onChanged }) {
  const [busy, setBusy] = useState(false);
  if (!reg) return null;
  const stop = (e) => { e.stopPropagation(); e.preventDefault(); };
  if (reg.xero_invoice_id) {
    const paid = reg.xero_invoice_status === 'PAID' || reg.paid_via === 'xero';
    const part = !paid && Number(reg.xero_amount_paid) > 0;
    const cls = paid ? 'bg-emerald-600 text-white border-emerald-700' : reg.xero_overdue ? 'bg-rose-100 text-rose-800 border-rose-300' : part ? 'bg-amber-100 text-amber-800 border-amber-300' : 'bg-emerald-50 text-emerald-800 border-emerald-300';
    const label = paid ? `Paid in Xero · ${reg.xero_invoice_number || ''}` : part ? `£${Number(reg.xero_amount_paid).toFixed(0)} received · ${reg.xero_invoice_number || ''}` : reg.xero_overdue ? `Overdue · ${reg.xero_invoice_number || 'Xero'}` : `Xero ${reg.xero_invoice_number || 'invoice'}`;
    return (
      <a href={reg.xero_invoice_url || '#'} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} title="Open in Xero" data-testid={`trn-xero-open-${reg.id}`} data-xero-state={paid ? 'paid' : part ? 'part' : reg.xero_overdue ? 'overdue' : 'open'}
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border ${cls}`}>
        <ExternalLink className="w-3 h-3" /> {label}
      </a>
    );
  }
  if (reg.balance_paid_at || reg.cancelled) return null;
  const raise = async (e) => {
    stop(e);
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/staff/training/registrations/${reg.id}/xero-invoice`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || 'Could not raise invoice');
      toast.success(`Xero invoice ${d.invoice_number || ''} raised for £${Number(d.amount || 0).toFixed(2)} — balance clears automatically once paid`);
      onChanged?.();
    } catch (err) { toast.error(err.message); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={raise} disabled={busy} title="Create an invoice for the outstanding balance in the ProTraining Xero organisation" data-testid={`trn-xero-raise-${reg.id}`}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border border-sky-300 bg-sky-50 text-sky-800 hover:bg-sky-100 disabled:opacity-50">
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <FileText className="w-3 h-3" />} Raise Xero invoice
    </button>
  );
}
